// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStateHook,
	createStore,
	createActionsHook,
	createHook,
} from '@atlassian/react-sweet-state';
import type { IssueLinks } from '@atlassian/jira-issue-shared-types/src/common/types/linked-issue-type.tsx';
import type { State } from './types.tsx';
import { actions } from './actions.tsx';

const Store = createStore<State, typeof actions>({
	name: 'issue-link-suggestions-store',
	initialState: {
		issueLinkSuggestions: new Set(),
	},
	actions,
});

export const selectIssueLinkSuggestions = (
	state: State,
	props: { existingIssueLinks?: IssueLinks },
) => {
	if (!props.existingIssueLinks?.linkedIssueKeys?.length) {
		return [...state.issueLinkSuggestions];
	}
	const linkedIssueKeys = new Set(props.existingIssueLinks.linkedIssueKeys);
	return [...state.issueLinkSuggestions].filter((item) => !linkedIssueKeys.has(item));
};

export const useIssueLinkSuggestions = createStateHook(Store, {
	selector: selectIssueLinkSuggestions,
});

export const useIssueLinkSuggestionsActions = createActionsHook(Store);

export const useIssueLinkSuggestionsStore = createHook(Store);
